import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getSessionMessages } from '~/api/sessions'
import type { TranscriptMessage } from '~/api/types'
import { MessageList } from '~/components/Transcript'
import { Button } from '~/components/ui/button'

// 대화 재생 패널. 세션 메시지를 시간순으로 role별 말풍선(user 우측/assistant 좌측)으로 렌더.
// 닫기 버튼이 있는 우측 슬라이드오버 형태로 표시한다. 헤더에서 세션 상세 페이지로 이동할 수 있다.
export function TranscriptPanel({
    sessionId,
    onClose,
}: {
    sessionId: string
    onClose: () => void
}) {
    const navigate = useNavigate()
    const [messages, setMessages] = useState<TranscriptMessage[]>([])
    const [error, setError] = useState<string | null>(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        let alive = true
        setLoading(true)
        setError(null)
        getSessionMessages(sessionId)
            .then((data) => {
                if (alive) setMessages(data)
            })
            .catch((e) => {
                if (alive) setError(e.message)
            })
            .finally(() => {
                if (alive) setLoading(false)
            })
        return () => {
            alive = false
        }
    }, [sessionId])

    function openDetail() {
        onClose()
        navigate(`/sessions/${sessionId}`)
    }

    return (
        <div className='fixed inset-0 z-50 flex justify-end'>
            <button
                type='button'
                aria-label='닫기'
                className='bg-background/60 absolute inset-0'
                onClick={onClose}
            />
            <div className='border-border bg-card relative flex h-full w-full max-w-xl flex-col border-l shadow-lg'>
                <div className='border-border flex items-center justify-between border-b p-4'>
                    <h2 className='krds-title text-foreground'>대화 재생</h2>
                    <div className='flex items-center gap-2'>
                        <Button
                            variant='outline'
                            size='sm'
                            onClick={openDetail}>
                            상세보기
                        </Button>
                        <Button variant='ghost' size='sm' onClick={onClose}>
                            닫기
                        </Button>
                    </div>
                </div>

                <div className='flex-1 overflow-y-auto p-4'>
                    {loading ? (
                        <p className='text-muted-foreground text-sm'>
                            불러오는 중…
                        </p>
                    ) : error ? (
                        <p className='text-destructive text-sm'>{error}</p>
                    ) : messages.length === 0 ? (
                        <p className='text-muted-foreground text-sm'>
                            메시지가 없어요.
                        </p>
                    ) : (
                        <MessageList messages={messages} />
                    )}
                </div>
            </div>
        </div>
    )
}
